<div class="login-page">
    <div class="login-page-box"></div>
    <div class="login-box">
        <div class="login-logo">
            <img src="assets/img/logo.png" alt="Logo" class="login-logo">
        </div>

        <div class="card card-outline card-info">
            <div class="card-header text-center">
                <h4><b>{{nombreSistema}}</b></h4><br>
                {{descripcionSistema}}
            </div>
            <div class="card-body login-card-body">
                <p class="login-box-msg"><label>Confirma tu identidad</label></p>

                <form [formGroup]="form" (ngSubmit)="send()" novalidate>
                    <div class="form-group col-md-12">
                        <label for="codigoVerificacion">Se ha enviado un correo de verificación</label>
                        <input type="text" class="form-control" id="codigoVerificacion"
                            placeholder="Ingresa el código de verificación" formControlName="codigoVerificacion"
                            [ngClass]="{ 'is-invalid': submitted && form.controls.codigoVerificacion.errors }">
                        <div *ngIf="submitted && form.controls.codigoVerificacion.errors" class="invalid-feedback">
                            <div *ngIf="form.controls.codigoVerificacion.errors.required">El código es requerido</div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <button type="button" class="btn btn-danger col-md-6" (click)="regresarLogin()">
                                <i class="fas fa-undo-alt"></i>
                                Regresar
                            </button>
                            <button type="submit" class="btn btn-info col-md-6">
                                <i class="fas fa-door-open"></i>
                                Acceder
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>